var kind = require("enyo/kind");

/**
 * [ModalDropdownSupport]{@link app.AppLayout.ModalDropdownSupport} allows a
 * dropdown to toggle the invisible scrim used to block interaction with the
 * content area of the layout.
 *
 * @mixin app.AppLayout.ModalDropdownSupport
 * @public
 */
module.exports = {

    /**
     * Flag whether to block interaction with page content.
     *
     * @name     blockContentInteraction
     * @type     {boolean}
     * @memberof app.AppLayout.ModalDropdownSupport
     * @public
     */

    /**
     * The amount of requests to block content interaction.
     *
     * @type     {number}
     * @memberof app.AppLayout.ModalDropdownSupport
     * @private
     */
    blockContentInteractionRequests: 0,

    /**
     * Disable interaction blocking by default. It needs to be enabled
     * explicitly, just to be safe.
     *
     * @memberof app.AppLayout.ModalDropdownSupport
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);

            if (this.blockContentInteraction === undefined) {
                this.blockContentInteraction = false;
            }

        };
    }),

    /**
     * If the dropdown is showing, we automatically trigger a request to block
     * content interaction.
     *
     * @memberof app.AppLayout.ModalDropdownSupport
     * @method
     * @private
     */
    showDropdown: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);

            this.set("blockContentInteractionRequests", this.get("blockContentInteractionRequests") + 1);
        };
    }),

    /**
     * If the dropdown is hidden, we automatically trigger a request to
     * re-enable content interaction.
     *
     * @memberof app.AppLayout.ModalDropdownSupport
     * @method
     * @private
     */
    hideDropdown: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);

            this.set("blockContentInteractionRequests", this.get("blockContentInteractionRequests") - 1);
        };
    }),

    /**
     * Block content interaction when requested at least once. Re-enable content
     * interaction if all blocking requests have been revoked.
     *
     * @param    {number}  oldCount  The previous number of requests
     * @memberof app.AppLayout.ModalDropdownSupport
     * @method
     * @private
     */
    blockContentInteractionRequestsChanged: function(oldCount) {
        var newCount = this.blockContentInteractionRequests;

        if (oldCount < 1 && newCount > 0) {
            this.app.view.blockContentInteraction();
        }

        if (oldCount > 0 && newCount < 1) {
            this.app.view.unblockContentInteraction();
        }
    },

    /**
     * Ensure the scrim will be hidden when the dropdown is destroyed
     *
     * @memberof app.AppLayout.ModalDropdownSupport
     * @method
     * @private
     */
    destroy: kind.inherit(function(sup) {
        return function() {
            this.set("blockContentInteractionRequests", 0);
            sup.apply(this, arguments);
        };
    })

};
